<div class="form-panel-container crud">
    <app-advanced-gridview
        [dataSource]="dataSource"
        [readOnly]="readOnly"
        [size]="100"
        [model]="tableModel"
        [menuItems]="menuItems"
        [contextualMenu]="tableModel.columnActionVisible"
        [sortEnabled]="sortEnabled"
        (menuClicked)="onAction($event)"
        (rowDoubleClicked)="onRowDoubleClick($event)"
        (itemsSorted)="onItemsSorted($event)"
        [ngClass]="{ 'screen-size-adapted': _context.item.isScreenSizeAdapted, 'not-screen-size-adapted': !_context.item.isScreenSizeAdapted }"></app-advanced-gridview>
    @if (_context.item.isScreenSizeAdapted) {
        <div class="footer-container">
            @if (totalColumnSize !== 100) {
                <span><fa-icon [icon]="warningIcon" class="warning-icon"></fa-icon></span>
                @if (totalColumnSize > 100) {
                    <span class="warning-text">Attention, la taille dépasse la largeur de la liste, certaines colonnes ne seront pas visibles.</span>
                } @else {
                    <span class="warning-text">Attention, la taille est inférieure à la largeur de la liste, de l'espace ne sera pas utilisé.</span>
                }
            }

            <span class="sum-text">Somme de la taille des colonnes : {{ totalColumnSize }} %</span>
        </div>
    }
    <div class="buttons-container">
        @if (!readOnly) {
            <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); onRecordsExported()">Exporter</button>
            @if (enumHelper.areNotEquals(FormMode, _context.mode, FormMode.Reading)) {
                <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); fileToUpload.click()">Importer</button>
                @if (memoryService.getConnectedUser().hasRight(getCreationRight())) {
                    <button mat-raised-button class="accent-button" (click)="onCreate()">Ajouter</button>
                }
            }
        }

        <input ng2FileSelect #fileToUpload class="file-to-upload" type="file" [uploader]="uploader" (change)="onFileSelected()" [hidden]="true" />
    </div>
    <ngx-spinner name="detail-spinner" bdColor="var(--spinner-background-color)" color="var(--spinner-color)" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
</div>
